import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen pt-28 pb-20 bg-[#F9F6F0] relative overflow-hidden">
      {/* Background drifting blobs */}
      <div className="bg-blob blob-gold top-[10%] left-[-5%] w-[400px] h-[400px] opacity-30" />
      <div className="bg-blob blob-saffron bottom-[15%] right-[-5%] w-[450px] h-[450px] opacity-35" />

      <div className="container mx-auto max-w-4xl px-6 md:px-12 relative z-10">
        
        {/* Header */}
        <div className="text-left mb-10">
          <span className="text-[10px] font-bold tracking-widest uppercase text-[#D97706] mb-2 block">
            Legal Agreement
          </span>
          <h1 className="text-3xl md:text-4xl font-bold font-vedic text-[#352520]">
            Terms of Service
          </h1>
        </div>

        {/* Content Box */}
        <div className="bg-white/60 backdrop-blur-md border border-[#EBE6DD]/60 rounded-3xl p-8 md:p-12 shadow-lg space-y-10 text-left">
          
          <section className="border-b border-[#EBE6DD]/40 pb-8">
            <h2 className="text-lg md:text-xl font-bold font-vedic text-[#352520] mb-4 flex items-center">
              <span className="text-[#D97706] font-mono text-base mr-3">01</span>
              Acceptance of Terms
            </h2>
            <p className="text-sm md:text-base text-[#5D4E37] font-light leading-relaxed">
              By accessing and using Vastuspace.AI, you accept and agree to be bound by the terms and
              provisions of this agreement. Your continued use of the platform constitutes your agreement to all such terms.
            </p>
          </section>

          <section className="border-b border-[#EBE6DD]/40 pb-8">
            <h2 className="text-lg md:text-xl font-bold font-vedic text-[#352520] mb-4 flex items-center">
              <span className="text-[#D97706] font-mono text-base mr-3">02</span>
              Use License
            </h2>
            <p className="text-sm md:text-base text-[#5D4E37] font-light leading-relaxed">
              Permission is granted to temporarily use Vastuspace.AI for personal, non-commercial purposes
              only. This is the grant of a license, not a transfer of title, and under this license you may not modify or copy the materials.
            </p>
          </section>

          <section className="border-b border-[#EBE6DD]/40 pb-8">
            <h2 className="text-lg md:text-xl font-bold font-vedic text-[#352520] mb-4 flex items-center">
              <span className="text-[#D97706] font-mono text-base mr-3">03</span>
              Disclaimer
            </h2>
            <p className="text-sm md:text-base text-[#5D4E37] font-light leading-relaxed">
              The AI-generated Vastu analysis and recommendations are for informational purposes only.
              Vastuspace.AI does not guarantee specific outcomes or energy improvements. Users should consult with certified Vastu
              experts for major structural architectural decisions.
            </p>
          </section>

          <section className="border-b border-[#EBE6DD]/40 pb-8">
            <h2 className="text-lg md:text-xl font-bold font-vedic text-[#352520] mb-4 flex items-center">
              <span className="text-[#D97706] font-mono text-base mr-3">04</span>
              User Data
            </h2>
            <p className="text-sm md:text-base text-[#5D4E37] font-light leading-relaxed">
              Floor plans and personal information uploaded to Vastuspace.AI are processed securely and used
              solely for analysis purposes. We implement standard encryption methods to protect your data and do not share user files with third parties without direct consent.
            </p>
          </section>

          <section className="pb-2">
            <h2 className="text-lg md:text-xl font-bold font-vedic text-[#352520] mb-4 flex items-center">
              <span className="text-[#D97706] font-mono text-base mr-3">05</span>
              Modifications
            </h2>
            <p className="text-sm md:text-base text-[#5D4E37] font-light leading-relaxed">
              Vastuspace.AI reserves the right to revise these terms at any time. Continued use of the service
              constitutes acceptance of the revised terms.
            </p>
          </section>

          <div className="pt-6 border-t border-[#EBE6DD]/40 text-left">
            <span className="text-xs text-[#826239] font-medium tracking-wide uppercase">
              Last updated: January 2025
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
